<div class="row" *ngIf="!isVertical">
    <div *ngFor="let artikelBild of artikelBilder" class="col">
        <div  *ngIf="artikelBild.bildKlein != null">
            <img src="data:image/jpeg;base64,{{artikelBild.bildKlein}}" (click)="onSelectImage(artikelBild)"/>
        </div>
    </div>
</div>

<div class="content" fxLayout="column" fxLayoutAlign="space-between" *ngIf="isVertical">
    <perfect-scrollbar class="scroll-container theme-customer" fxFlex="auto" [config]="config" [scrollIndicators]="true">
        <div class="scrollable-content">
            <div *ngFor="let artikelBild of artikelBilder" class="p-2">
                <div *ngIf="artikelBild.bildKlein != null && artikelBild.bildKlein != ''">
                    <img src="data:image/jpeg;base64,{{artikelBild.bildKlein}}" (click)="onSelectImage(artikelBild)"/>
                </div>
                <div *ngIf="(artikelBild.bildKlein == null || artikelBild.bildKlein == '') && artikelBild.bild != null">
                    <img src="data:image/jpeg;base64,{{artikelBild.bild}}" (click)="onSelectImage(artikelBild)"/>
                </div>
            </div>
        </div>
    </perfect-scrollbar>
</div>
